import React, { ChangeEvent, MutableRefObject, useEffect, useRef, useState } from 'react'
import { CalenderIcon, CloseIcon, DownIcon, FormIconDataPicker, IdIcon, NewWarningIcon, SearchIcon, UpIcon } from '../iconSet/IconSet'
import { AdministrativeLevel, AdministrativeLevels, EarlyWarning, EarlyWarningTypeTypes, FlatAdmin, NTWAdminData, NTWDataRefType } from './CreateWarningTypes'
import { convertToOffsetDateTime, flatMap, paginationList, parseCSVManually, sideFieldCount, SubscriberDataType, validateCSVFormat } from './CommonMethods'
import { maldivesAdministrativeLevel, sriLankaAdministrationLevel } from './FixedDataSet'
import { AdminData } from './MapSelectorPopup'
import useInputValidate from '../../hooks/useInputValidate'
import { SelectItemTypes } from '../../CommonTypes'
import { InputGroupPropsTypes } from '../inputComp/InputGroupType'
import InputGroup from '../inputComp/InputGroup'
import MapSelector from './MapSelector'
import { APICallGenerateEWMsgRequest, APICallGenerateProcKeyRequest, APICallNewNTWRequest, APICallNewWarningRequest, APIRequestAddAreaTypes, APIRequestAddNTWAreaTypes, APIRequestAddNTWTypes, APIRequestWarningAddTypes, APIWarningTypeResponseType } from '../../services/APIEarlyWarningService'
import AlertDialog from '../popupComp/AlertDialog'
import { APIGetUserAreas } from './CreateWarningService'

import loadLightIcon from '../../images/icons/load-light.gif'
import loadDarkIcon from '../../images/icons/load-dark.gif'
import { useTheme } from '../../context/ThemeContext'
import { APIGetAllCustomSubscribers, Subscriber } from './EarlyWarningService'

type NTWWarningProps = {
    ewType: APIWarningTypeResponseType;
    username: string;
}

const NTWWarning = (props: NTWWarningProps) => {

    const { theme } = useTheme()
    const COUNTRY = process.env.REACT_APP_COUNTRY

    // Custom hook
    const {validateField} = useInputValidate()
    const [hiddenIslandCodes, setHiddenIslandCodes] = useState<string[]>([])

    const [isLoading, setIsLoading] = useState<boolean>(false)

    const [alertDialogState, setAlertDialogState] = useState(false);
    const [alertTitle, setAlertTitle] = useState('');
    const [alertDescription, setAlertDescription] = useState('');
    const [alertYesCallback, setAlertYesCallback] = useState<(() => void) | undefined>(undefined); // for Yes
    const [alertOkCallback, setAlertOkCallback] = useState<(() => void) | undefined>(undefined);  // for OK

    const showAlertDialog = (
    title: string,
    description: string,
    yesCallback?: () => void,
    okCallback?: () => void
    ) => {
    setAlertTitle(title);
    setAlertDescription(description);
    setAlertYesCallback(() => yesCallback); // Will show Yes/Cancel if defined
    setAlertOkCallback(() => okCallback);   // Will trigger only on OK
    setAlertDialogState(true);
    };

    // Number of rows in table
    const [numberOfRows, setNumberOfRows] = useState<number>(10)
    const numberOfRowsRef = useRef<HTMLInputElement | null>(null)

    // Supportive document
    const [fileName, setFileName] = useState<string>('Upload');
    const fileInputRef = useRef<HTMLInputElement>(null);

    const ntwNumberRef = useRef<HTMLInputElement | null>(null)
    const ntwRequestNameRef = useRef<HTMLInputElement | null>(null)
    const ntwValidityStartRef = useRef<HTMLInputElement | null>(null)
    const ntwValidityEndRef = useRef<HTMLInputElement | null>(null)
    const ntwDaRef = useRef<HTMLInputElement | null>(null)

    const ntwTextAreaEnglishRef = useRef<HTMLTextAreaElement | null>(null)
    const ntwTextAreaDhivehiRef = useRef<HTMLTextAreaElement | null>(null)
    const ntwTextAreaSinhalaRef = useRef<HTMLTextAreaElement | null>(null)
    const ntwTextAreaBengaliRef = useRef<HTMLTextAreaElement | null>(null)
    const ntwReportedLinkRef = useRef<HTMLInputElement | null>(null)

    const ntwTextAreaCusEnglishRef = useRef<HTMLTextAreaElement | null>(null)
    const ntwTextAreaCusDhivehiRef = useRef<HTMLTextAreaElement | null>(null)
    const ntwTextAreaCusSinhalaRef = useRef<HTMLTextAreaElement | null>(null)
    const ntwTextAreaCusBengaliRef = useRef<HTMLTextAreaElement | null>(null)
    const ntwTextAreaCusTamilRef = useRef<HTMLTextAreaElement | null>(null)

    const [messagingAreaStatus, setMessageAreaStatus] = useState<boolean>(false)

    const [csvErrors, setCSVErrors] = useState<string | null>(null)
    const [fileCSVName, setFileCSVName] = useState<string>('Upload');
    const fileInputCSVRef = useRef<HTMLInputElement>(null)
    const [csvData, setCSVData] = useState<SubscriberDataType[]>([])

    const csvSubNameRef = useRef<HTMLInputElement | null>(null)

    const subscriberSaveRef = useRef<HTMLInputElement | null>(null)

    const [isCSVDataPikerOpen, setIsCSVDataPikerOpen] = useState<boolean>(false)
    const [isCSVDataPickerLoading, setIsCSVDataPickerLoading] = useState<boolean>(false)

    // Selected country
    const country = process.env.REACT_APP_COUNTRY

    // Area selection status
    const [areaSelectType, setAreaSelectType] = useState<'table' | 'map'>('table')

    const [startDate, setStartDate] = useState<string>('')
    const handleStartDateChange = () => {
        if(ntwValidityStartRef.current) {
            console.log("data start" ,ntwValidityStartRef.current.value)
            setStartDate(ntwValidityStartRef.current.value)
        }
    }

    const [endDate, setEndDate] = useState<string>('')
    const handleEndDateChange = () => {
        if(ntwValidityEndRef.current) {
            console.log("data end" ,ntwValidityEndRef.current)
            setEndDate(ntwValidityEndRef.current.value)
        }
    }

    const dataMap: InputGroupPropsTypes[] = [
        {
            type: 'text',
            icon: <IdIcon width="1.5rem" color="var(--color-main-white)" />,
            color: 'var(--color-accent-bg)',
            placeholder: 'Enter MWA Number',
            label: 'NTW Number',
            name: 'NTWNumber',
            required: true,
            componentInputElement: ntwNumberRef,
            disabled: true
        },
        {
            type: 'text',
            icon: <IdIcon width="1.5rem" color="var(--color-main-white)" />,
            color: 'var(--color-accent-bg)',
            placeholder: 'Enter Request Name',
            label: 'Request Name',
            name: 'RequestName',
            required: false,
            componentInputElement: ntwRequestNameRef,
            disabled: true
        },
        {
            type: 'date-time',
            icon: <CalenderIcon width="1.5rem" color="var(--color-main-white)" />,
            color: 'var(--color-accent-bg)',
            placeholder: 'Enter start valid period',
            label: 'validity start time',
            name: 'validityStartTime',
            required: true,
            componentInputElement: ntwValidityStartRef,
            onChange: handleStartDateChange
        },
        {
            type: 'date-time',
            icon: <CalenderIcon width="1.5rem" color="var(--color-main-white)" />,
            color: 'var(--color-accent-bg)',
            placeholder: 'Enter end valid period',
            label: 'validity end time',
            name: 'validityEndTime',
            required: true,
            componentInputElement: ntwValidityEndRef,
            onChange: handleEndDateChange
        },
        {
            type: 'date-time',
            icon: <CalenderIcon width="1.5rem" color="var(--color-main-white)" />,
            color: 'var(--color-accent-bg)',
            placeholder: 'Enter end valid period',
            label: 'NTW Date',
            name: 'NTWDate',
            required: true,
            componentInputElement: ntwDaRef,
        }
    ]


    // Table data row
    //const [tableData, setTableData] = useState<AdministrativeLevels>(sriLankaAdministrationLevel)
    const [selectedCodes, setSelectedCodes] = useState(new Set());
    const [filterTableData, setFilterTableData] = useState<FlatAdmin[]>([])
    const [tableData, setTableData] = useState<FlatAdmin[]>([])
    const [pagination, setPagination] = useState<FlatAdmin[][]>([])
    const [selectedPagination, setSelectedPagination] = useState<number>(0)

    const [NTWTableData, setNTWTableData] = useState<AdminData[]>([])
    const NTWTableDataRef = useRef<AdminData[]>([])
    const NTWObjectRef = useRef<NTWDataRefType>({
        
        validityStartTime: '',
        validityEndTime: '',
        aswDate: '',
        adminData: [],
        desEnglish: '',
        desDhivehi: '',
        desSinhala: '',
        desBengali: '',
        reportedLink: '',
        supportDocument: null,
        warningId: '',
        warningNumber: '',
        requestName: '',

        desCusEnglish: '',
        desCusDhivehi: '',
        desCusSinhala: '',
        desCusBengali: '',
        desCusTamil: '',
    })

    const [selectedArea, setSelectedArea] = useState<string[]>([])
    const handleCheckBox = (event: React.ChangeEvent<HTMLInputElement>) => {
        
        if (event.target.checked) {
            setSelectedArea(prevState => [...prevState, event.target.name])
        } else {
            setSelectedArea(prevState => prevState.filter(item => item !== event.target.name))
        }
    }

    // Pagination next prev navigation
    const paginationNavigation = ( side: "next" | "prev") => {
        if (side === "next") {
            if (pagination.length > selectedPagination + 1) {
                setSelectedPagination(prevState => prevState + 1)
            }
           
        } else if (side === "prev") {
            if (0 <= selectedPagination - 1){
                setSelectedPagination(prevState => prevState - 1)
            }
        }
    }

    const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
        if (event.target.files && event.target.files.length > 0) {
            setFileName(event.target.files[0].name);
            NTWObjectRef.current.supportDocument = event.target.files[0]
        } else {
            setFileName('Upload');
        }
    }

    const handleGenerateEWMessageData = async (event: React.MouseEvent<HTMLButtonElement>) => {
        setIsLoading(true)
        if (NTWObjectRef.current) 
        {
            
            if(ntwValidityStartRef.current && ntwValidityEndRef.current && NTWTableDataRef.current && ntwTextAreaEnglishRef.current && ntwTextAreaDhivehiRef.current && ntwReportedLinkRef.current && fileInputRef.current && ntwNumberRef.current && ntwRequestNameRef.current && ntwDaRef.current && csvSubNameRef.current && subscriberSaveRef.current) 
            {
                NTWObjectRef.current.warningNumber = ntwNumberRef.current.value
                NTWObjectRef.current.requestName = ntwRequestNameRef.current.value
                NTWObjectRef.current.validityStartTime = ntwValidityStartRef.current.value
                NTWObjectRef.current.validityEndTime = ntwValidityEndRef.current.value
                NTWObjectRef.current.aswDate = ntwDaRef.current.value
                
                NTWTableDataRef.current.map(item => {
                    NTWObjectRef.current.adminData.push(item.data as NTWAdminData)
                })
                //NTWObjectRef.current.adminData = NTWTableDataRef.current
                NTWObjectRef.current.desEnglish = ntwTextAreaEnglishRef.current.value
                NTWObjectRef.current.desDhivehi = ntwTextAreaDhivehiRef.current.value

                if (COUNTRY === "SRI_LANKA" && ntwTextAreaSinhalaRef.current)
                {
                    NTWObjectRef.current.desSinhala = ntwTextAreaSinhalaRef.current.value
                }
    
                if (COUNTRY === "MALDIVES" && ntwTextAreaBengaliRef.current)
                {
                    NTWObjectRef.current.desBengali = ntwTextAreaBengaliRef.current.value
                }
                
                NTWObjectRef.current.reportedLink = ntwReportedLinkRef.current.value
                NTWObjectRef.current.warningId = props.ewType.warningId

                const ntwValidityStartRefField = validateField(ntwValidityStartRef)
                const ntwValidityEndRefField = validateField(ntwValidityEndRef)

                if (ntwValidityStartRefField && ntwValidityEndRefField)
                {
                    const ntwData: NTWDataRefType = NTWObjectRef.current
                                                                            
                    const ntwAdminData: APIRequestAddAreaTypes[] = []
            
                    ntwData.adminData.map(area => {
                        const newAdmin: APIRequestAddAreaTypes = {
                            code: area.code,
                            administrationName: area.adminName,
                            administrationLevel: area.adminLevel,
                            startDate: convertToOffsetDateTime(area.startDate),
                            endDate: convertToOffsetDateTime(area.endDate)
                        }
                        ntwAdminData.push(newAdmin)
                    })
                    
                    const NTWNewRequestBody: APIRequestWarningAddTypes = {
                        triggerType: "ADV",
                        type: 'NTW',
                        warningNumber: ntwData.warningNumber,
                        requestName: ntwData.requestName,
                        validityStartTime: convertToOffsetDateTime(ntwData.validityStartTime),
                        validityEndTime: convertToOffsetDateTime(ntwData.validityEndTime),
                        effectedAreas: ntwAdminData,
                        messageBodyEnglish: ntwData.desEnglish,
                        messageBodyDhivehi: ntwData.desDhivehi,
                        messageBodySinhala: ntwData.desSinhala,
                        messageBodyBengali: ntwData.desBengali,
                        reportLink: ntwData.reportedLink,
                        supportiveDocument: ntwData.supportDocument,
                        warningId: ntwData.warningId,
                        csvData: csvData,
                        isCsvSave: subscriberSaveRef.current.checked,
                        csvName: csvSubNameRef.current.value === '' || csvSubNameRef.current.value === null ? fileCSVName.split('.')[0] : csvSubNameRef.current.value
                    }
                    try {
                        const response = await APICallGenerateEWMsgRequest(NTWNewRequestBody)

                        if (!response.errorCode) 
                        {
                            //console.log(response);

                            if (ntwTextAreaEnglishRef.current && ntwTextAreaDhivehiRef.current) {
                                // After got response set to field
                                ntwTextAreaEnglishRef.current.value = response.data.ew_generalMsgLanBase // English data in response
                                ntwTextAreaDhivehiRef.current.value =response.data.ew_generalMsgLanDV // Dhivehi data in response

                                if (COUNTRY === "SRI_LANKA" && ntwTextAreaSinhalaRef.current)
                                {
                                    ntwTextAreaSinhalaRef.current.value = response.data.ew_generalMsgLanSI // Sinhala data in response
                                }
                    
                                if (COUNTRY === "MALDIVES" && ntwTextAreaBengaliRef.current)
                                {
                                    ntwTextAreaBengaliRef.current.value = response.data.ew_generalMsgLanBN // Bengali data in response
                                }
                            }
                        }
                        else {
                            switch (response.errorCode) {
                                case 1010:
                                    console.log("❌ ", response.errorMessage);
                                    showAlertDialog("Unauthorized", "❌ Unauthorized request");
                                    break
                                default:
                                    console.log("❌ ", response.errorMessage);
                                    showAlertDialog("Error", "❌ Error adding data");
                            }

                        }
                    }
                    catch (ex) {
                        console.error("❌ HRW submit exception:", ex);
                        showAlertDialog("Submit Error", "❌ HRW submit exception");
                    }
                } else {
                    showAlertDialog("Validation Error", "Validation error");
                }
            }
        }
    }

    // Handle save data
    const handleSaveClick = async (event: React.MouseEvent<HTMLButtonElement>) => {

        if (NTWObjectRef.current) 
        {
            
            if(ntwValidityStartRef.current && ntwValidityEndRef.current && NTWTableDataRef.current && ntwTextAreaEnglishRef.current && ntwTextAreaDhivehiRef.current && ntwReportedLinkRef.current && fileInputRef.current && ntwNumberRef.current && ntwRequestNameRef.current && ntwDaRef.current && ntwTextAreaBengaliRef.current && csvSubNameRef.current && subscriberSaveRef.current && ntwTextAreaCusEnglishRef.current && ntwTextAreaCusDhivehiRef.current) 
            {
                NTWObjectRef.current.warningNumber = ntwNumberRef.current.value
                NTWObjectRef.current.requestName = ntwRequestNameRef.current.value
                NTWObjectRef.current.validityStartTime = ntwValidityStartRef.current.value
                NTWObjectRef.current.validityEndTime = ntwValidityEndRef.current.value
                NTWObjectRef.current.aswDate = ntwDaRef.current.value
                
                NTWTableDataRef.current.map(item => {
                    NTWObjectRef.current.adminData.push(item.data as NTWAdminData)
                })
                //NTWObjectRef.current.adminData = NTWTableDataRef.current
                NTWObjectRef.current.desEnglish = ntwTextAreaEnglishRef.current.value
                NTWObjectRef.current.desCusEnglish = ntwTextAreaCusEnglishRef.current.value

                NTWObjectRef.current.desDhivehi = ntwTextAreaDhivehiRef.current.value
                NTWObjectRef.current.desCusDhivehi = ntwTextAreaCusDhivehiRef.current.value

                if (COUNTRY === "SRI_LANKA" && ntwTextAreaSinhalaRef.current)
                {
                    NTWObjectRef.current.desSinhala = ntwTextAreaSinhalaRef.current.value
                }
    
                if (COUNTRY === "MALDIVES" && ntwTextAreaBengaliRef.current && ntwTextAreaDhivehiRef.current)
                {
                    NTWObjectRef.current.desBengali = ntwTextAreaBengaliRef.current.value
                    NTWObjectRef.current.desDhivehi = ntwTextAreaDhivehiRef.current.value
                }
                
                NTWObjectRef.current.reportedLink = ntwReportedLinkRef.current.value
                NTWObjectRef.current.warningId = props.ewType.warningId

                const ntwValidityStartRefField = validateField(ntwValidityStartRef)
                const ntwValidityEndRefField = validateField(ntwValidityEndRef)

                if (ntwValidityStartRefField && ntwValidityEndRefField)
                {
                    const ntwData: NTWDataRefType = NTWObjectRef.current
                                                                            
                    const ntwAdminData: APIRequestAddAreaTypes[] = []
            
                    ntwData.adminData.map(area => {
                        const newAdmin: APIRequestAddAreaTypes = {
                            code: area.code,
                            administrationName: area.adminName,
                            administrationLevel: area.adminLevel,
                            startDate: convertToOffsetDateTime(area.startDate),
                            endDate: convertToOffsetDateTime(area.endDate)
                        }
                        ntwAdminData.push(newAdmin)
                    })
                    
                    const NTWNewRequestBody: APIRequestWarningAddTypes = {
                        triggerType: "ADV",
                        type: 'NTW',
                        warningNumber: ntwData.warningNumber,
                        requestName: ntwData.requestName,
                        validityStartTime: convertToOffsetDateTime(ntwData.validityStartTime),
                        validityEndTime: convertToOffsetDateTime(ntwData.validityEndTime),
                        effectedAreas: ntwAdminData,
                        messageBodyEnglish: ntwData.desEnglish,
                        messageBodyDhivehi: ntwData.desDhivehi,
                        messageBodySinhala: ntwData.desSinhala,
                        messageBodyBengali: ntwData.desBengali,
                        reportLink: ntwData.reportedLink,
                        supportiveDocument: ntwData.supportDocument,
                        warningId: ntwData.warningId,
                        csvData: csvData,
                        isCsvSave: subscriberSaveRef.current.checked,
                        csvName: csvSubNameRef.current.value === '' || csvSubNameRef.current.value === null ? fileCSVName.split('.')[0] : csvSubNameRef.current.value,

                        messageCusBodyEnglish: ntwData.desCusEnglish,
                        messageCusBodyDhivehi: ntwData.desCusDhivehi,
                        messageCusBodySinhala: ntwData.desCusSinhala,
                        messageCusBodyBengali: ntwData.desCusBengali,
                        messageCusBodyTamil: ntwData.desCusTamil,
                    }

                    //console.log(">>>>>> ", NTWNewRequestBody)
            
                    // Send request
                    try
                    {
                        const response = await APICallNewWarningRequest(NTWNewRequestBody)
                        
                        if (!response.errorCode)
                        {
                            console.log("✅ NTW submitted successfully");
                            showAlertDialog("Success", "✅ NTW submitted successfully!", undefined, () => window.location.reload());
                            window.location.reload()
                        } 
                        else 
                        {
                            switch (response.errorCode) {
                                case 1010:
                                    console.log("❌ ", response.errorMessage);
                                    showAlertDialog("Unauthorized", "❌ Unauthorized request");
                                    break
                                default:
                                    console.log("❌ ", response.errorMessage);
                                    showAlertDialog("Error", "❌ Error adding data");
                            }
                            
                        }
                    } 
                    catch (ex)
                    {
                        console.error("❌ NTW submit exception:", ex);
                        showAlertDialog("Submit Error", "❌ NTW submit exception");
                    }
                } 
                else 
                {
                    showAlertDialog("Validation Error", "❌ Validation error");
                } 
            }
        }
    }

    const [allowedAreas, setAllowedAreas] = useState<string[]>([])
    useEffect(() => {
        const getUserAreas = async () => {
            const response = await APIGetUserAreas()
            //console.log('AREAS ->', response.data)
            if (!response)
            {
                showAlertDialog('Error', '❌ data loading failed')
            }
            
            setAllowedAreas(response.data)

            if (country === "SRI_LANKA") {
                const flat = flatMap(sriLankaAdministrationLevel, selectedArea)
                setTableData(flat)
                setFilterTableData(flat)
            } else if (country === "MALDIVES") {
                const flat = flatMap(maldivesAdministrativeLevel, selectedArea)
                const filtered: FlatAdmin[] = flat.filter(item => response.data.some(code => item.code.startsWith(code)))
                setTableData(filtered)
                setFilterTableData(filtered)
            }
        }
        getUserAreas()
    }, [])

    useEffect(() => {
        setPagination(paginationList(filterTableData, numberOfRows))
    }, [tableData, filterTableData, numberOfRows])

    // Handle table search
    const handelSearchChange = (event: ChangeEvent<HTMLInputElement>) => {
        if (event.target.value === "") {
            setFilterTableData(tableData)
        } else {
            setFilterTableData(tableData.filter(item => item.name.toLowerCase().includes(event.target.value.toLowerCase())))
        }
    }

    const handleNTWStartDate = (event: ChangeEvent<HTMLInputElement>) => {
        if (NTWTableDataRef.current) {
            NTWTableDataRef.current = NTWTableDataRef.current.map(item => {
                if (item.type === 'NTW' && item.data.code === event.target.name) {
                    return {
                        ...item,
                        data: {
                            ...item.data,
                            startDate: event.target.value,
                        },
                    };
                }
                return item;
            });
        }
    };

    const handleNTWEndDate = (event: ChangeEvent<HTMLInputElement>) => {
        if (NTWTableDataRef.current) {
            NTWTableDataRef.current = NTWTableDataRef.current.map(item => {
                if (item.type === 'NTW' && item.data.code === event.target.name) {
                    return {
                        ...item,
                        data: {
                            ...item.data,
                            endDate: event.target.value,
                        },
                    };
                }
                return item;
            });
        }
    }
    
    const getAllChildIslandCodes = (level: AdministrativeLevel): string[] => {
        if (!level.children) return [];

        const codes: string[] = [];
        Object.entries(level.children).forEach(([code, child]) => {
            if (child.adminLevel === 'island') {
                codes.push(code);
            }

            // Recurse deeper
            codes.push(...getAllChildIslandCodes(child));
        });

        return codes;
    }

    const findAdminByCode = (levels: AdministrativeLevels, code: string): AdministrativeLevel | null => {
        for (const [key, level] of Object.entries(levels)) {
            if (key === code) return level;
            if (level.children) {
            const result = findAdminByCode(level.children, code);
            if (result) return result;
            }
        }
        return null;
    }

    useEffect(() => {
        const visibleData = filterTableData.filter(item => !hiddenIslandCodes.includes(item.code));
        const paginated = paginationList(visibleData, numberOfRows);
        setPagination(paginated);

        // Reset to first page if current page is out of bounds after filtering
        if (selectedPagination >= paginated.length) {
            setSelectedPagination(0);
        }
    }, [filterTableData, numberOfRows, hiddenIslandCodes])
    
    // Handle check box click
    const handleCheckBoxClick = (event: ChangeEvent<HTMLInputElement>) => {
        handleCheckBox(event);

        setSelectedCodes(prev => {
            const updated = new Set(prev);
            if (event.target.checked) {
                updated.add(event.target.name);
            } else {
                updated.delete(event.target.name);
            }
            return updated;
        });

        if (event.target.checked) {
            if (!NTWTableDataRef.current.some(item => item.type === 'NTW' && item.data.code === event.target.name)) {
                const data = tableData.find(obj => obj.code === event.target.name);
                if (data) {
                    NTWTableDataRef.current.push({
                        type: 'NTW',
                        data: {
                            name: data.name,
                            code: data.code,
                            adminName: data.adminLevel,
                            adminLevel: data.adminLevel,
                            startDate: ntwValidityStartRef.current?.value || '',
                            endDate: ntwValidityEndRef.current?.value || '',
                        }
                    });
                }
            }
        } else {
            NTWTableDataRef.current = NTWTableDataRef.current.filter(
                item => !(item.type === 'NTW' && item.data.code === event.target.name)
            );
        }
    }

    // Handle Row number change
    const handleRowNumberChanged = (event: ChangeEvent<HTMLInputElement>) => {
        setNumberOfRows(event.target.valueAsNumber)
    }

    useEffect(() => {
        const now = new Date();
        const plus24h = new Date(now.getTime() + 24 * 60 * 60 * 1000);

        const formatDateTimeLocal = (date: Date) => {
        const offset = date.getTimezoneOffset();
        const localDate = new Date(date.getTime() - offset * 60 * 1000);
        return localDate.toISOString().slice(0, 16); // yyyy-MM-ddTHH:mm
        };

        if (ntwValidityStartRef.current) 
        {
            ntwValidityStartRef.current.value = formatDateTimeLocal(now);
        }

        if (ntwValidityEndRef.current) 
        {
            ntwValidityEndRef.current.value = formatDateTimeLocal(plus24h);
        }

        setStartDate(formatDateTimeLocal(now))
        setEndDate(formatDateTimeLocal(plus24h))

        if (ntwRequestNameRef.current/*  && ntwDateRef.current */) 
        {
            ntwRequestNameRef.current.value = props.username
            
            const now = new Date();

            const year = now.getFullYear()
            const month = String(now.getMonth() + 1).padStart(2, '0')
            const day = String(now.getDate()).padStart(2, '0')
            const hours = String(now.getHours()).padStart(2, '0')
            const minutes = String(now.getMinutes()).padStart(2, '0')

            // Format: "2025-07-21T14:30"
            const currentDateTime = `${year}-${month}-${day}T${hours}:${minutes}`
            //ntwDateRef.current.value = currentDateTime
        }
    }, [])

    const handleTableClick = () => {
        setSelectedCodes(new Set())
        NTWTableDataRef.current = []
        setSelectedArea([])
        setAreaSelectType('table')
    }

    const handleMapClick = () => {
        setSelectedCodes(new Set())
        NTWTableDataRef.current = []
        setSelectedArea([])
        setAreaSelectType('map')
    }

    useEffect(() => {
        const fetchInitialData = async () => {
            try {
                const response = await APICallGenerateProcKeyRequest(props.ewType.warningId); // Pass prop here
                if (response && !response.errorCode) {
                    //console.log("✅ API data loaded: ", response);
                    // Example: store a process key in state
                    // setProcKey(response.processKey);

                    if (ntwNumberRef.current) {
                        ntwNumberRef.current.value = response.data;
                    }

                } else {
                    console.warn("⚠️ API returned an error:", response?.errorMessage);
                    showAlertDialog("Error", "Failed to load initial data");
                }
            } catch (error) {
                console.error("❌ Error fetching data:", error);
                showAlertDialog("Network Error", "Failed to fetch initial data.");
            }
        };

        fetchInitialData();
    }, [props.ewType]); 

    useEffect(() => {
        if (ntwRequestNameRef.current)
        {
            ntwRequestNameRef.current.value = props.username
        }
    }, [])

    const handleCSVFileChange = (event: ChangeEvent<HTMLInputElement>) => {
        setCSVErrors(null)
        if (event.target.files && event.target.files.length > 0) {
            setFileCSVName(event.target.files[0].name)
            const file = event.target.files[0]
            
            // Validate File Extension
            if (!file.name.endsWith('.csv'))
            {
                setCSVErrors("Invalid file type. Please upload a CSV file.")
                event.target.value = ''
                return
            }
            else
            {
                setFileCSVName(file.name)
                
                const reader = new FileReader()

                reader.onload = (e) => {

                    const text = e.target?.result as string

                    if (!validateCSVFormat(text).valid)
                    {
                        setCSVErrors("Invalid CSV format. Please upload a CSV file with the correct format.")
                        event.target.value = ''
                        return
                    }

                    const parsedData = parseCSVManually(text)
                    setCSVData(parsedData)
                }

                reader.onerror = () => {
                    setCSVErrors("Error reading CSV file. Please try again.")
                }
                
                reader.readAsText(file)
            }
        } else {
            setFileCSVName('Upload');
        }
    }

    const clearCSV = () => {
        if (!fileInputCSVRef.current) return

        fileInputCSVRef.current.value = ''
        setFileCSVName('Upload')
        setCSVData([])
        setCSVErrors(null)
    }

    const handleClickSaveAndSubmit = (event: React.MouseEvent<HTMLButtonElement>) => {
        if (csvErrors !== null)
        {
            showAlertDialog("CSV Error", "Loaded CSV file detected error. Please fix CSV error before submit. if submit without fix CSV error, CSV data will not be uploaded. Do you need to proceed?", () => handleSaveClick(event), undefined)
        }
        else
        {
            showAlertDialog("Confirm Submit", "Are you sure you want to submit this early warning?", () => handleSaveClick(event), undefined)
        }
    }

    const handleClearCSV = () => {
        setCSVErrors(null)
        setFileCSVName('Upload')
        setCSVData([])
    }

    const existingCSVDataRef = useRef<string[]>([])
    const existingCSVDataSetRef = useRef<SubscriberDataType[]>([])
    const [existingCSVFilterData, setExistingCSVFilterData] = useState<string[]>([])

    // existing data change handle
    const handleChangeExistingDataSearch = (event: ChangeEvent<HTMLInputElement>): void => {
        if (event.target.value === "") 
        {
            setExistingCSVFilterData(existingCSVDataRef.current);
        } 
        else 
        {
            setExistingCSVFilterData(
                existingCSVDataRef.current.filter((item) =>
                    item.toLowerCase().includes(event.target.value.toLowerCase())
                )
            );
        }
    }

    useEffect(() => {
        const fetchExistingCSVData = async () => {
            setIsCSVDataPickerLoading(true)
            const response = await APIGetAllCustomSubscribers(props.ewType.warningId)

            if (!response.status)
            {

            }
            const tempData: SubscriberDataType[] = []
            const tempFileNames: string[] = []

            response.data?.map(item => {
                tempFileNames.push(item.name)
                item.subscribers.map((subscriber: Subscriber) => {
                    const sub: SubscriberDataType = {
                        name: item.name,
                        whatsappContact: subscriber.whatsappContact,
                        whatsapp: subscriber.whatsapp,
                        smsContact: subscriber.smsContact,
                        sms: subscriber.sms,
                        viberContact: subscriber.viberContact,
                        viber: subscriber.viber,
                        email: subscriber.email
                    }
                    tempData.push(sub)
                })
            })
            existingCSVDataSetRef.current = tempData
            existingCSVDataRef.current = tempFileNames
            setExistingCSVFilterData(tempFileNames)
        }

        fetchExistingCSVData()
        setIsCSVDataPickerLoading(false)
    }, [])

    const handleClickFilteredCSV = (sub: string): void => {
        setCSVData(existingCSVDataSetRef.current.filter(item => item.name === sub))
        setCSVErrors(null)
        csvSubNameRef.current!.value = sub
        setFileCSVName(sub)
        setIsCSVDataPikerOpen(false)
    }

    return (
        <div>
            <div className='details-selector-wrapper'>
                <div className='title'>
                    <span>Early Warning Details ({props.ewType.warningName})</span>
                </div>
                <div className='details-selector-wrapper-container' style={{backgroundColor: 'transparent'}}>
                    <div className={`left-side`}>
                        {dataMap.slice(0, sideFieldCount(dataMap.length)).map((field, index) => (
                            <InputGroup key={index} {...field}/>
                        ))}
                    </div>

                    <div className={`right-side`}>
                        {dataMap.slice(sideFieldCount(dataMap.length)).map((field, index) => (
                            <InputGroup key={index} {...field}/>
                        ))}
                    </div>
                </div>
            </div>
            <div className='details-selector-wrapper'>
                <div className='title'>
                    <span>Early Warning Details (Area Selection)</span>
                </div>
                <div className='tab-button-wrapper'>
                    <span style={{backgroundColor: areaSelectType === 'table' ? 'var(--color-warning-table-bg)' : 'var(--color-container-form-bg)'}} onClick={() => handleTableClick()}>table view mode</span>
                    <span style={{backgroundColor: areaSelectType === 'map' ? 'var(--color-warning-table-bg)' : 'var(--color-container-form-bg)'}} onClick={() => handleMapClick()}>map view mode</span>
                </div>
                {areaSelectType === 'table' && (
                    <div className='details-selector-wrapper-table-container'>
                        <div className='area-table-wrapper'>
                            <div className='field-container'>
                                <div className='input-group' style={{width: '20rem'}}>
                                    <label htmlFor="">display row count</label>
                                    <input ref={numberOfRowsRef} defaultValue={10} min={10} max={30} type="number" onChange={(e) => handleRowNumberChanged(e)} />
                                </div>
                                <div className='input-group'>
                                    <i><SearchIcon width="1rem" color="var(--color-main-white)" /></i>
                                    <input type="text" name="" id="" placeholder='Search location' onChange={(e) => handelSearchChange(e)}/>
                                </div>
                            </div>
                            <div className='table-wrapper'>
                                <div className='row header'>
                                    <div className='cell' style={{flex: 0.2, minWidth: '3rem'}}>
                                        <span></span>
                                    </div>
                                    <div className='cell' style={{minWidth: '8.3rem'}}>
                                        <span>Administration Name</span>
                                    </div>
                                    <div className='cell' style={{minWidth: '8.3rem'}}>
                                        <span>Administration Level</span>
                                    </div>
                                    <div className='cell' style={{minWidth: '8.3rem'}}>
                                        <span>Start Date</span>
                                    </div>
                                    <div className='cell' style={{minWidth: '8.3rem'}}>
                                        <span>End Date</span>
                                    </div>
                                </div>

                                {pagination[selectedPagination]?.map((item, index) => (
                                    <div key={index} className='row'>
                                        <div className='cell' style={{flex: 0.2, minWidth: '3rem'}}>
                                            <input type="checkbox" name={item.code} onChange={(e) => handleCheckBoxClick(e)} checked={selectedCodes.has(item.code)}/>
                                        </div>
                                        <div className='cell' style={{minWidth: '8rem'}}>
                                            <span>{item.name}</span>
                                        </div>
                                        <div className='cell' style={{minWidth: '8rem'}}>
                                            <span>{item.adminLevel}</span>
                                        </div>
                                        
                                        <div className='cell' style={{minWidth: '8rem', justifyContent: 'center'}}>
                                            <input type="datetime-local" defaultValue={startDate} name={item.code} onChange={(e) => handleNTWStartDate(e)} style={{width: '8rem'}}/>
                                        </div>
                                        <div className='cell' style={{minWidth: '8rem', justifyContent: 'center'}}>
                                            <input type="datetime-local" defaultValue={endDate} name={item.code} onChange={(e) => handleNTWEndDate(e)} style={{width: '8rem'}}/>
                                        </div>
                                    </div>
                                ))}

                            </div>
                        </div>
                        <div className='pagination-wrapper'>
                            <div className='icon-page-box' style={{marginBottom: "0.7rem"}} onClick={(e) => paginationNavigation("prev")}>&lt;</div>
                            <div className='page-wrapper'>
                                {pagination.map((page, index) => (
                                    <div key={index} className={selectedPagination === index ? 'icon-page-box selected' : 'icon-page-box'} onClick={(e) => setSelectedPagination(index)}>{index + 1}</div>
                                ))}
                            </div>
                            <div className='icon-page-box' style={{marginBottom: "0.7rem"}} onClick={(e) => paginationNavigation("next")}>&gt;</div>
                        </div>
                    </div>
                )}
                {areaSelectType === 'map' && (
                    <div className='map-wrapper'>
                        <MapSelector type='NTW' setData={NTWTableDataRef} startDate={startDate} endDate={endDate} tableData={NTWTableData} setTableData={setNTWTableData} allowedAreas={allowedAreas}/>
                    </div>
                )}
            </div>
            <div className='details-selector-wrapper'>
                <div className='title'>
                    <span>Early Warning Details (Intended Dissemination of Information to People)</span>
                </div>
                <div className='details-selector-wrapper-form-container'>
                    <div className='form-container'>
                        <span>message body SMS - english</span>
                        <textarea ref={ntwTextAreaEnglishRef} name="" id=""></textarea>
                    </div>
                    <div className='form-container'>
                        <span>message body SMS - dhivehi</span>
                        <textarea ref={ntwTextAreaDhivehiRef} name="" id=""></textarea>
                    </div>

                    {COUNTRY === "SRI_LANKA" ? (
                        <div className='form-container'>
                            <span>message body SMS - sinhala</span>
                            <textarea ref={ntwTextAreaSinhalaRef} name="" id=""></textarea>
                        </div>
                    ) : COUNTRY === "MALDIVES" ? (
                        <div className='form-container'>
                            <span>message body SMS - Bengali</span>
                            <textarea ref={ntwTextAreaBengaliRef} name="" id=""></textarea>
                        </div>
                    ) : null}
                    
                    <div className='form-container' style={{alignItems: 'center'}}>
                        <span>report link</span>
                        <input ref={ntwReportedLinkRef} type='text' name="" id=""></input>
                    </div>
                    <div className='button-wrapper'>
                        <button onClick={(e) => handleGenerateEWMessageData(e)}>generate EW message data</button>
                    </div>

                    {/* More message options */}
                    <div className='message-more-wrapper'>
                        <div className='title-wrapper'>
                            <span className='title' onClick={() => setMessageAreaStatus(prevState => !prevState)}>More Messaging options..</span>
                            <div>
                                {messagingAreaStatus ? <UpIcon width='0.8rem' color='var(--color-text)' /> : <DownIcon width='1rem' color='var(--color-text)' />}
                            </div>
                        </div>
                        <div className='data-wrapper' style={{ maxHeight: messagingAreaStatus ? '500px' : '0' }}>
                            
                            <div className='messaging-legend-wrapper'>
                                <span>Message Placeholders</span>
                                <div>
                                    <span>Warning Id: {'${warningId}'}</span>
                                    <span>Warning Name: {'${warningName}'}</span>
                                    <span>Area Name: {'${areaName}'}</span>
                                    <span>Severity: {'${severity}'}</span>
                                    <span>Validity Start Time: {'${validityStart}'}</span>
                                    <span>Validity End Time: {'${validityEnd}'}</span>
                                </div>
                            </div>

                            <div className='form-container'>
                                <span>local message body - english</span>
                                <textarea ref={ntwTextAreaCusEnglishRef} name="" id=""></textarea>
                            </div>
                            
                            {COUNTRY === "SRI_LANKA" ? (
                                <>
                                    <div className='form-container'>
                                        <span>local message body - sinhala</span>
                                        <textarea ref={ntwTextAreaCusSinhalaRef} name="" id=""></textarea>
                                    </div>

                                    <div className='form-container'>
                                        <span>local message body - tamil</span>
                                        <textarea ref={ntwTextAreaCusTamilRef} name="" id=""></textarea>
                                    </div>
                                </>
                                
                            ) : COUNTRY === "MALDIVES" ? (
                                <>
                                    <div className='form-container'>
                                        <span>local message body - dhivehi</span>
                                        <textarea ref={ntwTextAreaCusDhivehiRef} name="" id=""></textarea>
                                    </div>

                                    <div className='form-container'>
                                        <span>local message body - Bengali</span>
                                        <textarea ref={ntwTextAreaCusBengaliRef} name="" id=""></textarea>
                                    </div>
                                </>
                                
                            ) : null}
                        </div>
                    </div>
                </div>
            </div>
            <div className='details-selector-wrapper'>
                <div className='title'>
                    <span>Early Warning Details (Additional Information to Support Approval)</span>
                </div>
                <div className='details-selector-wrapper-form-container'>
                    <div className='form-container' style={{alignItems: 'center'}}>
                        <span>supportive documents</span>
                        <div className="custom-upload-container">
                            <span className="upload-text">{fileName}</span>
                            <label className="browse-button">
                                Browse
                                <input type="file" ref={fileInputRef} onChange={handleFileChange} className="file-input" />
                            </label>
                            </div>
                    </div>
                </div>
            </div>
            <div className='details-selector-wrapper'>
                <div className='title'>
                    <span>Custom Subscribers</span>
                </div>
                <div className='details-selector-wrapper-form-container'>
                    <div className='form-container' style={{ alignItems: 'center' }}>
                        <span>Custom Subscribers (CSV)</span>
                        <div className="custom-upload-container">
                            <span className="upload-text">{fileCSVName}</span>
                            <label className={csvData.length > 0 ? 'browse-button clear-btn' : 'browse-button'}>
                                { csvData.length > 0 ? (
                                    <button onClick={(e) => handleClearCSV()}>Clear</button>
                                ) : (
                                    <>
                                        Browse
                                        <input type="file" ref={fileInputCSVRef} onChange={handleCSVFileChange} className="file-input" accept='.csv,text/csv' style={{ textTransform: 'none' }} />
                                    </>
                                )}
                                
                            </label>
                        </div>
                    </div>
                    {csvErrors && (
                        <div className='csv-form-container'>
                            <span>{csvErrors}</span>
                            <span className='clear-button' onClick={(e) => clearCSV()}>Remove CSV</span>
                        </div>
                    )}
                    <div className='form-container' style={{ alignItems: 'center' }}>
                        <span>Custom Subscribers (CSV) Name</span>
                        <div className="custom-upload-container-picker">
                            <div className='pick-icon' onClick={(e) => setIsCSVDataPikerOpen(prevState => !prevState)}>
                                <FormIconDataPicker color='var(--color-text)' width='1rem'/>
                            </div>
                            <input type="text" ref={csvSubNameRef} placeholder={`Default name (${fileCSVName.split('.')[0]})`} />
                        </div>
                    </div>
                    <div className='check-form-container'>
                        <div className='check-box'>
                            <input type="checkbox" ref={subscriberSaveRef} id="save-subs_csv" />
                            <label htmlFor="save-subs_csv">Save subscribers data</label>
                        </div>
                    </div>
                </div>
            </div>
            <div className={`button-wrapper`} style={{gridArea: 'button'}}>
                <div className={`left-side`}></div>
                <div className={`right-side`}>
                    <button className={`button-normal`} style={{backgroundColor: 'var(--color-main-red)'}}>cancel</button>
                    <button className={`button-normal`} onClick={(e) => 
                        showAlertDialog(
                            "Confirm Submit",
                            "Are you sure you want to submit this early warning?",
                            () => handleSaveClick(e), undefined)
                    }>save & submit</button>
                </div>
            </div>
            {isCSVDataPikerOpen && (
                <div className="data-picker-table-wrapper-new">
                    <div className="data-picker-table-container">
                        <div className="search-wrapper">
                            <input type="text" placeholder="Search CSVs" onChange={(e) => handleChangeExistingDataSearch(e)} />
                            <div className="search-icon">
                                <SearchIcon width="1rem" color="var(--color-main-white)" />
                            </div>
                            <div className="close-icon" onClick={(e) => setIsCSVDataPikerOpen(false)} >
                                <CloseIcon width="1.5rem" color="var(--color-text)" />
                            </div>
                        </div>
                        <div className="row header">
                            {/* <span style={{ width: '33%' }}>Country</span> */}
                            <span style={{ width: '100%' }}>CSV Name</span>
                        </div>
                        
                        {isCSVDataPickerLoading ? (
                            <div className="searching-data">
                                <img src={theme === 'dark' ? loadDarkIcon : theme === 'light' ? loadLightIcon : theme === 'colorful' ? loadLightIcon : ''} alt="" />
                                <span>Searching CSVs...</span>
                            </div>
                        ) : (
                            <div className="data-wrapper">
                                {existingCSVFilterData.map((sub, index) => (
                                    <div
                                        key={index}
                                        className="row"
                                        onClick={(e) => handleClickFilteredCSV(sub)}
                                    >
                                        <span style={{ width: '100%', textAlign: 'left' }}>{sub}</span>
                                    </div>
                                ))}
                            </div>
                        )}

                        {!isCSVDataPickerLoading && existingCSVFilterData.length === 0 && (
                            <div className="searching-data">
                                <span>No CSVs found.</span>
                            </div>
                        )}
                        
                    </div>
                </div>
            )}
            {alertDialogState && (
            <AlertDialog
                title={alertTitle}
                description={alertDescription}
                windowState={alertDialogState}
                setWindowState={setAlertDialogState}
                function={alertYesCallback}
                okFunction={alertOkCallback}
            />
            )}
        </div>
    )
}

export default NTWWarning